import React from 'react';
import { isEmpty } from 'lodash';
import Select from 'react-select';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useTranslation } from 'react-i18next';
import { customStyles, shortenString } from '../../../Components/helper';
import BottomProductAttributeTableRows from './BottomProductAttributeTabelRows';

const notAvailable = (isLoading, allImportedProducts, showNewRow, t) => {
  return (
    !isLoading &&
    allImportedProducts &&
    isEmpty(allImportedProducts) &&
    !showNewRow && (
      <tr>
        <td className=" text-center" colSpan={16}>
          <h6>{t('DEVLOPMENT_ORDER.PRODUCT_BOM_MODAL.BOTTOM_PRODUCT_ATTRIBUTES.NO_PRODUCT_AVAILBLE')}</h6>
        </td>
      </tr>
    )
  );
};

const newArrayShow = (showNewRow, allImportedProducts, selectedProduct, addNewProduct, handleCancle, t) => {
  return (
    showNewRow && (
      <tr>
        <td className="text-left" />
        <td className="last-fix-col text-left " />
        <td className="text-left">
          <Select
            name="productRef"
            maxMenuHeight={132}
            menuPosition="fixed"
            menuPlacement="top"
            options={allImportedProducts}
            getOptionLabel={(option) => `${option.number} - ${shortenString(option.description, 10)}`}
            getOptionValue={(option) => `${option._id}`}
            value={selectedProduct}
            styles={customStyles}
            classNamePrefix="common-select"
            onChange={(e) => addNewProduct(e)}
            placeholder={t('DEVLOPMENT_ORDER.PRODUCT_BOM_MODAL.BOTTOM_PRODUCT_ATTRIBUTES.PRODUCT_REF')}
          />
        </td>
        <td className="text-left" />
        <td className="text-left" />
        <td className="text-left" />
        <td className="text-left" />
        <td className="text-left" />
        <td className="text-left" />
        <td className="text-left" />
        <td className="text-left" />
        <td className="text-left" />
        <td className="text-left" />
        <td className="text-left" />
        <td className="text-left" />
        <td className="text-left" />
        <td className="text-left" />
        <td className="text-left" />
        <td className="text-left" />
        <td className="text-left">
          <button
            className="btn"
            onClick={handleCancle}
            title={t('DEVLOPMENT_ORDER.PRODUCT_BOM_MODAL.BOTTOM_PRODUCT_ATTRIBUTES.CANCEL')}
            type="button"
            aria-label={t('COMMON_LABEL.CANCEL')}
          >
            <span className="icon-cancel" />
          </button>
        </td>
      </tr>
    )
  );
};

const products = (onSortColumn, sortTable, iconsChange, t) => {
  return (
    <th
      className="w-280px text-left first-fix-col"
      onClick={() => {
        onSortColumn('number');
      }}
    >
      <span className="cursor-pointer">
        {t('DEVLOPMENT_ORDER.PRODUCT_BOM_MODAL.BOTTOM_PRODUCT_ATTRIBUTES.PRODUCT_REF')}
        {sortTable.propertyName === 'number' ? <>{iconsChange()}</> : <i className="icon-Table-Up font-weight-heavy f-14 text-black ml-1" />}
      </span>
    </th>
  );
};

const brands = (onSortColumn, iconsChange, sortTable, t) => {
  return (
    <th className="w-120px text-left" onClick={() => onSortColumn('brand')}>
      <span className="cursor-pointer">
        {t('DEVLOPMENT_ORDER.PRODUCT_BOM_MODAL.BOTTOM_PRODUCT_ATTRIBUTES.BRAND')}
        {sortTable.propertyName === 'brand' ? <>{iconsChange()}</> : <i className="icon-Table-Up font-weight-heavy f-14 text-black ml-1" />}
      </span>
    </th>
  );
};

const seasons = (onSortColumn, iconsChange, sortTable, t) => {
  return (
    <th className="w-120px text-left" onClick={() => onSortColumn('season')}>
      <span className="cursor-pointer">
        {t('DEVLOPMENT_ORDER.PRODUCT_BOM_MODAL.BOTTOM_PRODUCT_ATTRIBUTES.SEASON')}
        {sortTable.propertyName === 'season' ? iconsChange() : <i className="icon-Table-Up font-weight-heavy f-14 text-black ml-1" />}
      </span>
    </th>
  );
};

const componentSupps = (onSortColumn, iconsChange, sortTable, t) => {
  return (
    <th
      className="w-200px text-left"
      onClick={() => {
        onSortColumn('ComponentSuppliers');
      }}
    >
      <span className="cursor-pointer">
        {t('DEVLOPMENT_ORDER.PRODUCT_BOM_MODAL.BOTTOM_PRODUCT_ATTRIBUTES.COMPONENT_SUPLIER')}
        {sortTable.propertyName === 'ComponentSuppliers' ? <>{iconsChange()}</> : <i className="icon-Table-Up font-weight-heavy f-14 text-black ml-1" />}
      </span>
    </th>
  );
};

const productSupps = (onSortColumn, iconsChange, sortTable, t) => {
  return (
    <th
      className="w-200px text-left"
      onClick={() => {
        onSortColumn('suppliers');
      }}
    >
      <span className="cursor-pointer">
        {t('DEVLOPMENT_ORDER.PRODUCT_BOM_MODAL.BOTTOM_PRODUCT_ATTRIBUTES.PRODUCT_SUPLIER')}
        {sortTable.propertyName === 'suppliers' ? <>{iconsChange()}</> : <i className="icon-Table-Up font-weight-heavy f-14 text-black ml-1" />}
      </span>
    </th>
  );
};

const subBrands = (onSortColumn, iconsChange, sortTable, t) => {
  return (
    <th className="w-120px text-left" onClick={() => onSortColumn('subBrand')}>
      <span className="cursor-pointer">
        {t('DEVLOPMENT_ORDER.PRODUCT_BOM_MODAL.BOTTOM_PRODUCT_ATTRIBUTES.SUB_BRAND')}
        {sortTable.propertyName === 'subBrand' ? <>{iconsChange()}</> : <i className="icon-Table-Up font-weight-heavy f-14 text-black ml-1" />}
      </span>
    </th>
  );
};

function BottomProductAttributesTable({
  handleSelectAll,
  isSelectAll,
  allImportedProducts,
  onSortColumn,
  sortTable,
  iconsChange,
  isLoading,
  showNewRow,
  selectedProduct,
  addNewProduct,
  handleCancle,
  onSelectCheckBox,
  selectedIdArray,
  hanldeUpdate,
  handleDelete,
  productRefs,
  expandGrandTotalChild,
  expandAllData,
  indexes,
  parentIndexes,
  count,
  handlePageNextInScroll,
  hasMore,
  subbrandAccess,
}) {
  const tableData = (item, i) => {
    return (
      <BottomProductAttributeTableRows
        item={item}
        i={i}
        onSelectCheckBox={onSelectCheckBox}
        selectedIdArray={selectedIdArray}
        hanldeUpdate={hanldeUpdate}
        handleDelete={handleDelete}
        expandGrandTotalChild={expandGrandTotalChild}
        parentIndexes={parentIndexes}
        array={allImportedProducts}
        subbrandAccess={subbrandAccess}
      />
    );
  };

  const expands = () => {
    return indexes?.length === count ? (
      <button className="btn-up-down" type="button" onClick={() => expandAllData()} aria-label="expand">
        <span className="icon-new-down-arrow-icon f-32 icon-inverse" />
      </button>
    ) : (
      <button className="btn-up-down" type="button" onClick={() => expandAllData()} aria-label="collapse">
        <span className="icon-new-down-arrow-icon f-32 " />
      </button>
    );
  };
  const { t } = useTranslation('common');

  return (
    <div id="ProductAttributeTable">
      <div
        id="scrollableDivBomUsage"
        style={{
          overflow: 'auto',
          maxHeight: '50vh',
        }}
      >
        <InfiniteScroll
          className="infinite-bom-bottom"
          scrollableTarget="scrollableDivBomUsage"
          dataLength={allImportedProducts?.length}
          hasMore={hasMore}
          next={handlePageNextInScroll}
          style={{ overflow: 'inherit' }}
        >
          <table className="table common-custom-table fixed-header mb-0" id="ProductAttributeTable">
            <thead>
              <tr>
                <th aria-label="select" className="text-left w-50px">
                  <div className="common-checkbox no-label checkbox-center">
                    <input
                      type="checkbox"
                      onChange={handleSelectAll}
                      name="checking_all"
                      id="checking_all"
                      checked={isSelectAll}
                      disabled={isEmpty(allImportedProducts)}
                    />
                    <label aria-label="select" htmlFor="checking_all" className="chklabel" />
                  </div>
                </th>
                {count !== 0 ? <th className="w-50px">{expands()}</th> : <th className="w-80px" />}
                {products(onSortColumn, sortTable, iconsChange, t)}
                <th
                  className="w-200px"
                  onClick={() => {
                    onSortColumn('description');
                  }}
                >
                  <span className="cursor-pointer">
                    {t('DEVLOPMENT_ORDER.PRODUCT_BOM_MODAL.BOTTOM_PRODUCT_ATTRIBUTES.PRODUCT_DESCRIPTION')}
                    {sortTable.propertyName === 'description' ? <>{iconsChange()}</> : <i className="icon-Table-Up font-weight-heavy f-14 text-black ml-1" />}
                  </span>
                </th>
                {productSupps(onSortColumn, iconsChange, sortTable, t)}
                {componentSupps(onSortColumn, iconsChange, sortTable, t)}
                {brands(onSortColumn, iconsChange, sortTable, t)}
                {subbrandAccess && subBrands(onSortColumn, iconsChange, sortTable, t)}
                {seasons(onSortColumn, iconsChange, sortTable, t)}
                <th
                  className="w-120px text-left"
                  onClick={() => {
                    onSortColumn('month');
                  }}
                >
                  <span className="cursor-pointer">
                    {t('DEVLOPMENT_ORDER.PRODUCT_BOM_MODAL.BOTTOM_PRODUCT_ATTRIBUTES.MONTH')}
                    {sortTable.propertyName === 'month' ? <>{iconsChange()}</> : <i className="icon-Table-Up font-weight-heavy f-14 text-black ml-1" />}
                  </span>
                </th>
                <th
                  className="w-120px text-left"
                  onClick={() => {
                    onSortColumn('year');
                  }}
                >
                  <span className="cursor-pointer">
                    {t('DEVLOPMENT_ORDER.PRODUCT_BOM_MODAL.BOTTOM_PRODUCT_ATTRIBUTES.YEAR')}
                    {sortTable.propertyName === 'year' ? <>{iconsChange()}</> : <i className="icon-Table-Up font-weight-heavy f-14 text-black ml-1" />}
                  </span>
                </th>
                <th
                  className="w-150px text-left"
                  onClick={() => {
                    onSortColumn('catOne');
                  }}
                >
                  <span className="cursor-pointer">
                    {t('DEVLOPMENT_ORDER.PRODUCT_BOM_MODAL.BOTTOM_PRODUCT_ATTRIBUTES.CATEGO0RY_1')}
                    {sortTable.propertyName === 'catOne' ? <>{iconsChange()}</> : <i className="icon-Table-Up font-weight-heavy f-14 text-black ml-1" />}
                  </span>
                </th>
                <th
                  className="w-150px text-left"
                  onClick={() => {
                    onSortColumn('catTwo');
                  }}
                >
                  <span className="cursor-pointer">
                    {t('DEVLOPMENT_ORDER.PRODUCT_BOM_MODAL.BOTTOM_PRODUCT_ATTRIBUTES.CATEGORIES_2')}
                    {sortTable.propertyName === 'catTwo' ? <>{iconsChange()}</> : <i className="icon-Table-Up font-weight-heavy f-14 text-black ml-1" />}
                  </span>
                </th>
                <th
                  className="w-150px text-left"
                  onClick={() => {
                    onSortColumn('catThree');
                  }}
                >
                  <span className="cursor-pointer">
                    {t('DEVLOPMENT_ORDER.PRODUCT_BOM_MODAL.BOTTOM_PRODUCT_ATTRIBUTES.CATEGORIES_3')}
                    {sortTable.propertyName === 'catThree' ? <>{iconsChange()}</> : <i className="icon-Table-Up font-weight-heavy f-14 text-black ml-1" />}
                  </span>
                </th>
                <th
                  className="w-150px text-left"
                  onClick={() => {
                    onSortColumn('catFour');
                  }}
                >
                  <span className="cursor-pointer">
                    {t('DEVLOPMENT_ORDER.PRODUCT_BOM_MODAL.BOTTOM_PRODUCT_ATTRIBUTES.CATEGORIES_4')}
                    {sortTable.propertyName === 'catFour' ? <>{iconsChange()}</> : <i className="icon-Table-Up font-weight-heavy f-14 text-black ml-1" />}
                  </span>
                </th>
                <th
                  className="w-150px text-left"
                  onClick={() => {
                    onSortColumn('size');
                  }}
                >
                  <span className="cursor-pointer">
                    {t('DEVLOPMENT_ORDER.PRODUCT_BOM_MODAL.BOTTOM_PRODUCT_ATTRIBUTES.SIZE')}
                    {sortTable.propertyName === 'size' ? <>{iconsChange()}</> : <i className="icon-Table-Up font-weight-heavy f-14 text-black ml-1" />}
                  </span>
                </th>
                <th
                  className="w-150px text-left"
                  onClick={() => {
                    onSortColumn('weight');
                  }}
                >
                  <span className="cursor-pointer">
                    {t('DEVLOPMENT_ORDER.PRODUCT_BOM_MODAL.BOTTOM_PRODUCT_ATTRIBUTES.WEIGHT')}
                    {sortTable.propertyName === 'weight' ? <>{iconsChange()}</> : <i className="icon-Table-Up font-weight-heavy f-14 text-black ml-1" />}
                  </span>
                </th>
                <th
                  className="w-150px text-left"
                  onClick={() => {
                    onSortColumn('quantity');
                  }}
                >
                  <span className="cursor-pointer">
                    {t('DEVLOPMENT_ORDER.PRODUCT_BOM_MODAL.BOTTOM_PRODUCT_ATTRIBUTES.QUNTITY')}
                    {sortTable.propertyName === 'quantity' ? <>{iconsChange()}</> : <i className="icon-Table-Up font-weight-heavy f-14 text-black ml-1" />}
                  </span>
                </th>

                <th
                  className="w-150px text-left"
                  onClick={() => {
                    onSortColumn('status');
                  }}
                >
                  <span className="cursor-pointer">
                    {t('DEVLOPMENT_ORDER.PRODUCT_BOM_MODAL.BOTTOM_PRODUCT_ATTRIBUTES.STATUS')}
                    {sortTable.propertyName === 'status' ? <>{iconsChange()}</> : <i className="icon-Table-Up font-weight-heavy f-14 text-black ml-1" />}
                  </span>
                </th>
                <th
                  className="w-150px text-left"
                  onClick={() => {
                    onSortColumn('colourWay');
                  }}
                >
                  <span className="cursor-pointer">
                    {t('DEVLOPMENT_ORDER.PRODUCT_BOM_MODAL.BOTTOM_PRODUCT_ATTRIBUTES.COLOUR_WAY')}
                    {sortTable.propertyName === 'colourWay' ? <>{iconsChange()}</> : <i className="icon-Table-Up font-weight-heavy f-14 text-black ml-1" />}
                  </span>
                </th>
                <th
                  className="w-150px text-left"
                  onClick={() => {
                    onSortColumn('colours');
                  }}
                >
                  <span className="cursor-pointer">
                    {t('DEVLOPMENT_ORDER.PRODUCT_BOM_MODAL.BOTTOM_PRODUCT_ATTRIBUTES.COLOUR_ART')}
                    {sortTable.propertyName === 'colours' ? <>{iconsChange()}</> : <i className="icon-Table-Up font-weight-heavy f-14 text-black ml-1" />}
                  </span>
                </th>
                <th
                  className="w-150px text-left"
                  onClick={() => {
                    onSortColumn('colourConfig');
                  }}
                >
                  <span className="cursor-pointer">
                    {t('DEVLOPMENT_ORDER.PRODUCT_BOM_MODAL.BOTTOM_PRODUCT_ATTRIBUTES.COLOUR_REF')}
                    {sortTable.propertyName === 'colourConfig' ? <>{iconsChange()}</> : <i className="icon-Table-Up font-weight-heavy f-14 text-black ml-1" />}
                  </span>
                </th>
                <th
                  className="w-200px text-left"
                  onClick={() => {
                    onSortColumn('isMatch');
                  }}
                >
                  <span className="cursor-pointer">
                    {t('DEVLOPMENT_ORDER.PRODUCT_BOM_MODAL.BOTTOM_PRODUCT_ATTRIBUTES.QUALITY_DATA_MATCH')}
                    {sortTable.propertyName === 'isMatch' ? <>{iconsChange()}</> : <i className="icon-Table-Up font-weight-heavy f-14 text-black ml-1" />}
                  </span>
                </th>
                <th
                  className="w-220px text-center last-fix-col"
                  onClick={() => {
                    onSortColumn('currentStatus');
                  }}
                >
                  <span className="cursor-pointer">
                    {t('DEVLOPMENT_ORDER.PRODUCT_BOM_MODAL.BOTTOM_PRODUCT_ATTRIBUTES.CURRENT_STATUS')}
                    {sortTable.propertyName === 'currentStatus' ? <>{iconsChange()}</> : <i className="icon-Table-Up font-weight-heavy f-14 text-black ml-1" />}
                  </span>
                </th>

                <th className="w-120px" />
              </tr>
            </thead>
            <tbody>
              {newArrayShow(showNewRow, productRefs, selectedProduct, addNewProduct, handleCancle, t)}
              {notAvailable(isLoading, allImportedProducts, showNewRow, t)}
              {!isLoading &&
                !isEmpty(allImportedProducts) &&
                allImportedProducts?.map((testItem, testIndex) => {
                  if (testItem.suppliers.length === 1) {
                    testItem.idPlusSupplierId = testItem._id + testItem?.suppliers[0]?._id;
                  }
                  return tableData(testItem, testIndex);
                })}
            </tbody>
          </table>
        </InfiniteScroll>
      </div>
    </div>
  );
}

export default BottomProductAttributesTable;
